<div class="formula-check-dialog">
    <h2 mat-dialog-title class="dialog-title">
        <i class="fas fa-robot" style="margin-right: 8px; color: #b84eff;"></i>
        AI Formula Check Results
    </h2>

    <mat-dialog-content class="dialog-content">
        <!-- Status Icon and Message -->
        <div class="status-section" [ngClass]="{ 'valid-formula': data.isValid, 'invalid-formula': !data.isValid }">
            <div class="status-icon">
                <i *ngIf="data.isValid" class="fas fa-check-circle" style="color: #4caf50; font-size: 24px;"></i>
                <i *ngIf="!data.isValid" class="fas fa-exclamation-triangle" style="color: #ff9800; font-size: 24px;"></i>
            </div>
            <div class="status-text">
                <h3 *ngIf="data.isValid">✅ Formula is Valid</h3>
                <h3 *ngIf="!data.isValid">⚠️ Formula Issues Detected</h3>
            </div>
        </div>

        <!-- Context (if available) -->
        <div *ngIf="data.context" class="context-section">
            <h4>📍 Parameter Context:</h4>
            <p class="context-text">{{ data.context }}</p>
        </div>

        <!-- Explanation -->
        <div class="explanation-section">
            <h4>Analysis:</h4>
            <p class="explanation-text">{{ data.explanation }}</p>
        </div>

        <!-- Formula Comparison Section -->
        <div class="formula-comparison">
            <!-- Current Formula -->
            <div class="formula-section">
                <h4>❌ Current Formula:</h4>
                <div class="formula-display current-formula">
                    <code>{{ data.currentFormula }}</code>
                </div>
            </div>

            <!-- Corrected Formula (ALWAYS shown when formula is invalid) -->
            <div *ngIf="!data.isValid" class="formula-section">
                <h4>🔧 AI Suggested Correction:</h4>
                <div class="formula-display corrected-formula">
                    <code>{{ data.correctedFormula || 'No correction available' }}</code>
                </div>
                <div *ngIf="!data.correctedFormula || data.correctedFormula.trim() === ''" class="warning-message">
                    <p><i class="fas fa-exclamation-triangle"></i> Unable to automatically generate a correction for this formula.</p>
                </div>

                <!-- Show if formulas are different -->
                <div *ngIf="data.correctedFormula && data.correctedFormula !== data.currentFormula" class="formula-diff-note">
                    <p><i class="fas fa-arrows-h"></i> <strong>Changes detected:</strong> Corrected formula differs from original</p>
                </div>

                <!-- Show if formulas are same -->
                <div *ngIf="data.correctedFormula && data.correctedFormula === data.currentFormula" class="formula-same-note">
                    <p><i class="fas fa-info-circle"></i> <strong>Note:</strong> AI suggests the same formula, but flagged potential issues in analysis</p>
                </div>
            </div>
        </div>

        <!-- Suggestions -->
        <div *ngIf="hasSuggestions" class="suggestions-section">
            <h4>💡 Suggestions:</h4>
            <ul class="suggestions-list">
                <li *ngFor="let suggestion of data.suggestions">{{ suggestion }}</li>
            </ul>
        </div>

        <!-- Token Usage -->
        <div *ngIf="hasTokenUsage" class="token-usage-section">
            <h4>🔢 Token Usage:</h4>
            <div class="token-stats">
                <div class="token-stat">
                    <span class="token-label">Input:</span>
                    <span class="token-value">{{ data.tokenUsage.promptTokens }}</span>
                </div>
                <div class="token-stat">
                    <span class="token-label">Output:</span>
                    <span class="token-value">{{ data.tokenUsage.responseTokens }}</span>
                </div>
                <div class="token-stat total">
                    <span class="token-label">Total:</span>
                    <span class="token-value">{{ data.tokenUsage.totalTokens }}</span>
                </div>
                <div class="token-status" [ngClass]="{ 'success': data.tokenUsage.userAccountUpdated, 'warning': !data.tokenUsage.userAccountUpdated }">
                    <i *ngIf="data.tokenUsage.userAccountUpdated" class="fas fa-check-circle"></i>
                    <i *ngIf="!data.tokenUsage.userAccountUpdated" class="fas fa-exclamation-triangle"></i>
                    <span>{{ data.tokenUsage.userAccountUpdated ? 'Account updated' : 'Account update failed' }}</span>
                </div>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dialog-actions">
        <!-- Valid formula actions -->
        <div *ngIf="data.isValid" class="valid-actions">
            <button mat-button (click)="onCancel()" class="secondary-button">
                Close
            </button>
        </div>

        <!-- Invalid formula actions -->
        <div *ngIf="!data.isValid" class="invalid-actions">
            <div class="action-prompt">
                <p><strong>⚠️ Please choose an action:</strong></p>
            </div>

            <div class="button-row">
                <!-- Apply correction button (only if correction is available) -->
                <button *ngIf="hasCorrection" mat-raised-button color="primary" (click)="onApplyCorrection()" class="apply-button">
                    <i class="fas fa-check-circle" style="margin-right: 5px;"></i>
                    ✅ Apply AI Correction
                </button>

                <!-- Keep original button -->
                <button mat-button (click)="onKeepOriginal()" class="secondary-button">
                    <i class="fas fa-times-circle" style="margin-right: 5px;"></i>
                    ❌ Keep Original (with errors)
                </button>

                <!-- Manual edit button when no correction available -->
                <button *ngIf="!hasCorrection" mat-button (click)="onKeepOriginal()" class="secondary-button">
                    <i class="fas fa-edit" style="margin-right: 5px;"></i>
                    Manual Edit Required
                </button>

                <!-- Cancel button -->
                <button mat-stroked-button (click)="onCancel()" class="tertiary-button">
                    Cancel
                </button>
            </div>
        </div>
    </mat-dialog-actions>
</div>